
export enum RequestedChangeItemActionCd {
	ADD = 'Add',
	DELETE = 'Delete',
	UPDATE = 'Update'}

